import type { ColliderDef } from './colliderTypes';

/**
 * Default colliders for the Arafat scene (Jabal Rahma / Mount of Mercy).
 * One large sphere sunk deep below the rock surface so only the top cap
 * protrudes as the mountain collision shell.
 * Fine-tune via dev tools Leva panel.
 */
export const ARAFAT_DEFAULT_COLLIDERS: ColliderDef[] = [
  {
    id: 'jabal-rahma',
    type: 'sphere',
    mode: 'solid',
    enabled: true,
    position: { x: -0.01, y: -3.76, z: -0.02 },
    radius: 3.4,
  },
  {
    id: 'summit-rock',
    type: 'box',
    mode: 'solid',
    enabled: true,
    position: { x: 0.004, y: -0.33, z: 0.014 },
    size: { x: 0.17, y: 0.47, z: 0.15 },
  },
  {
    id: 'scene-boundary',
    type: 'cylinder',
    mode: 'hollow',
    enabled: true,
    blocksLineOfSight: false,
    position: { x: -0.01, y: -1, z: -0.02 },
    radius: 6.2,
    height: 2.7,
  },
];
